import React from 'react';
import Transactions from '.';

const RefundTransactions = () => (
  <>
    <Transactions
      title="Refund Transactions"
      transactionType="REFUND"
    />
  </>
);

export default RefundTransactions;
